/**
 * Rôles Azure AD utilisés pour l'authentification et le contrôle d'accès aux routes.
 */
export enum UserRole {
  ADMINISTRATOR = 'Ward.Administrator',
  COLLABORATEUR = 'Ward.Collaborateur',
  STUDENT = 'Etudiant',
}

/**
 * Types d'utilisateur pour le layout et l'UI.
 * Utilisé par userStore.userType pour conditionner l'affichage.
 *
 * Mapping 1:1 avec UserRole (rôles Azure AD) :
 *   UserRole.STUDENT        → USER_TYPE.STUDENT
 *   UserRole.COLLABORATEUR  → USER_TYPE.COLLABORATEUR
 *   UserRole.ADMINISTRATOR  → USER_TYPE.ADMINISTRATOR
 */
export const USER_TYPE = {
  STUDENT: 'Student',
  COLLABORATEUR: 'Collaborateur',
  ADMINISTRATOR: 'Administrator',
} as const;
